import {
  ChevronRight as ArrowForwardIos,
  Copy as ContentCopy,
  Tag as TagIcon,
  Trash2 as Delete
} from "lucide-react";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const actionLabelMap = {
  add: "Adicionar",
  remove: "Remover"
};

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  const actionLabel = actionLabelMap[data?.tagAction || data?.action] || actionLabelMap.add;
  const tagName = data?.tagName || "Tag não definida";

  return (
    <div
      style={{
        backgroundColor: "#FAFFFB",
        padding: "8px",
        borderRadius: "8px",
        boxShadow: "rgba(0, 0, 0, 0.05) 0px 3px 5px",
        border: "1px solid rgba(58, 186, 56, 0.25)",
        width: 190
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#3ABA38",
          width: "18px",
          height: "18px",
          top: "20px",
          left: "-12px",
          cursor: "pointer"
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />

      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{ width: "12px", height: "12px", color: "#3ABA38" }}
        />

        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{ width: "12px", height: "12px", color: "#3ABA38" }}
        />
      </div>

      <div
        style={{
          fontSize: "16px",
          flexDirection: "row",
          display: "flex",
          color: "#232323"
        }}
      >
        <TagIcon
          style={{
            width: "16px",
            height: "16px",
            marginRight: "4px",
            marginTop: "4px",
            color: "#3ABA38"
          }}
        />
        <div style={{ color: "#232323", fontSize: "16px" }}>Tag</div>
      </div>

      <div
        style={{
          color: "#232323",
          fontSize: "12px",
          marginTop: "6px",
          backgroundColor: "#F1FBF1",
          borderRadius: "5px",
          padding: "6px"
        }}
      >
        <div style={{ fontWeight: 600 }}>{actionLabel}</div>
        <div
          style={{
            marginTop: "4px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
          title={tagName}
        >
          {tagName}
        </div>
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#3ABA38",
          width: "18px",
          height: "18px",
          top: "72%",
          right: "-11px",
          cursor: "pointer"
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          style={{
            color: "#ffffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: "none"
          }}
        />
      </Handle>
    </div>
  );
});
